import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ps-0 mt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mb-25 pingo-card" }, {
    default: _withCtx(() => [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "v-card-header border-bottom" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Configurações")
      ], -1)),
      _createElementVNode("ul", _hoisted_1, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/configuracoes/conta" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Conta ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/configuracoes/enderecos" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" Endereços ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/configuracoes/politica-de-privacidade" }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" Política de Privacidade ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/configuracoes/termos-e-condicoes" }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Termos e Condições ")
            ])),
            _: 1
          })
        ])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("form", null, [
        _createElementVNode("div", { class: "mb-20" }, [
          _createElementVNode("h5", { class: "fw-semibold mb-8" }, "Termos e Condições"),
          _createElementVNode("p", null, "Visualize aqui os termos e condições da plataforma.")
        ]),
        _createElementVNode("span", { class: "d-block fw-semibold mb-10" }, " Autenticação de dois fatores "),
        _createElementVNode("p", null, " A autenticação de dois fatores é uma medida de segurança aprimorada. Uma vez habilitada, você precisará fornecer dois tipos de identificação ao fazer login. Autenticação via Google e SMS são suportados. "),
        _createElementVNode("span", { class: "d-block mt-20 fw-semibold mb-10" }, "Verificação Secundária"),
        _createElementVNode("p", null, " A autenticação de dois fatores é uma medida de segurança aprimorada. Uma vez habilitada, você precisará fornecer dois tipos de identificação ao fazer login. Autenticação via Google e SMS são suportados. "),
        _createElementVNode("span", { class: "d-block mt-20 fw-semibold mb-10" }, "Códigos de Backup"),
        _createElementVNode("p", null, " A autenticação de dois fatores é uma medida de segurança aprimorada. Uma vez habilitada, você precisará fornecer dois tipos de identificação ao fazer login. Autenticação via Google e SMS são suportados. "),
        _createElementVNode("span", { class: "d-block mt-20 fw-semibold mb-10" }, " Notificações de desktop, email, chat, compra "),
        _createElementVNode("p", null, " A autenticação de dois fatores é uma medida de segurança aprimorada. Uma vez habilitada, você precisará fornecer dois tipos de identificação ao fazer login. Autenticação via Google e SMS são suportados. ")
      ], -1))
    ]),
    _: 1
  }))
}